import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

// Fetch GalbElHabeb
export const GalbElHabeb = createAsyncThunk(
  "product/GalbElHabeb",
  async (data, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");

      const response = await axios.post(
        `${BASE_URL}/product/builder/getData`,
        data,
        {
          headers: { token },
        }
      );

      const result = response.data?.data;
      // console.log(result)
      // Check if result is empty or missing
      if (!result || Object.keys(result).length === 0) {
        return {
          link: data.link,
          count: 1,
          img: "https://api.markaship.com/uploads/waiting.png",
          name: "",
        };
      }

      return result;
    } catch (error) {
      if (error.response?.status === 404) {
        return {
          link: data.link,
          count: 1,
          img: "https://api.markaship.com/uploads/waiting.png",
          name: "",
        };
      }

      return rejectWithValue(error.response?.data || "Failed to load request");
    }
  }
);

// Fetch all products in cart
export const fetchAllProductInCarts = createAsyncThunk(
  "product/fetchAllProductInCarts",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.get(`${BASE_URL}/product/builder/AllData`, {
        headers: { token },
      });

      if (!response.data.data || response.data.data.length === 0) {
        return [];
      }

      return response.data.data;
    } catch (error) {
      if (error.response?.status === 404) return [];
      return rejectWithValue(error.response?.data || "Failed to load requests");
    }
  }
);

// Update product pricing
export const updateProductPricing = createAsyncThunk(
  "product/updateProductPricing",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      let formData = data.image instanceof File ? new FormData() : data;

      if (data.image instanceof File) {
        Object.entries(data).forEach(([key, value]) =>
          formData.append(key, value)
        );
      }

      const response = await axios.post(
        `${BASE_URL}/product/Pricing/${id}`,
        formData,
        {
          headers: {
            token,
            ...(formData instanceof FormData
              ? {}
              : { "Content-Type": "application/json" }),
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update order");
    }
  }
);

// Update product
export const updateProduct = createAsyncThunk(
  "product/updateProduct",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      let formData = data.image instanceof File ? new FormData() : data;
      // console.log("Kordy +" + data.image)
      if (data.image instanceof File) {
        Object.entries(data).forEach(([key, value]) =>
          formData.append(key, value)
        );
      }

      const response = await axios.put(
        `${BASE_URL}/product/builder/${id}`,
        formData,
        {
          headers: {
            token,
            ...(formData instanceof FormData
              ? {}
              : { "Content-Type": "application/json" }),
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update order");
    }
  }
);

// upload product Gallary
export const uploadProductImages = createAsyncThunk(
  "product/uploadProductImages",
  async ({ id, images }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const formData = new FormData();

      images.forEach((img) => {
        formData.append("images", img);
      });

      const response = await axios.put(
        `${BASE_URL}/product/builder/${id}/images`,
        formData,
        {
          headers: {
            token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to upload images");
    }
  }
);

// Delete One image (product Gallary)
export const deleteProductOneImage = createAsyncThunk(
  "product/deleteProductOneImage",
  async ({ productId, index }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");

      const response = await axios.delete(
        `${BASE_URL}/product/builder/${productId}/images`,
        {
          headers: { token },
          data: { index: [index] },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete image");
    }
  }
);

// Delete All image (product Gallary)
export const deleteAllProductImages = createAsyncThunk(
  "product/deleteAllProductImages",
  async (productId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");

      const response = await axios.delete(
        `${BASE_URL}/product/builder/${productId}/AllImages`,
        {
          headers: { token },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete all images"
      );
    }
  }
);

export const createProductItem = createAsyncThunk(
  "product/createProductItem",
  async (data, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No access token found");

      const response = await axios.post(
        `${BASE_URL}/product/builder`,
        { ...data },
        {
          headers: {
            token,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get product items by ID
export const getProductItemById = createAsyncThunk(
  "product/getProductItemById",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      const currency = localStorage.getItem("currency");

      const response = await axios.get(`${BASE_URL}/product/builder`, {
        headers: { token, iso: currency },
      });

      return response.data.data || [];
    } catch (error) {
      if (error.response?.status === 404) return [];
      return rejectWithValue(error.response?.data || "Failed to load requests");
    }
  }
);

// Update product item
export const updateProductItem = createAsyncThunk(
  "product/updateProductItem",
  async ({ itemId, data }, { rejectWithValue }) => {
    try {
      // console.log(data)
      // console.log(itemId)
      const token = localStorage.getItem("accessToken");
      const response = await axios.put(
        `${BASE_URL}/product/builder/${itemId}`,
        data,
        {
          headers: { token },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Delete product item
export const deleteProductItem = createAsyncThunk(
  "product/deleteProductItem",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      await axios.delete(`${BASE_URL}/product/builder/${id}`, {
        headers: { token },
      });
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update Product Received
export const updateProductReceived = createAsyncThunk(
  "product/updateProductReceived",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      let formData = data.image instanceof File ? new FormData() : data;

      if (data.image instanceof File) {
        Object.entries(data).forEach(([key, value]) =>
          formData.append(key, value)
        );
      }

      const response = await axios.post(
        `${BASE_URL}/product/Received/${id}`,
        formData,
        {
          headers: {
            token,
            ...(formData instanceof FormData
              ? {}
              : { "Content-Type": "application/json" }),
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update order");
    }
  }
);

// Send product request
export const sendProductRequest = createAsyncThunk(
  "product/sendProductRequest",
  async (productId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      // console.log(productId)
      const response = await axios.post(
        `${BASE_URL}/product/Requests/${productId}`,
        {},
        {
          headers: {
            token: token,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to send product request"
      );
    }
  }
);

// Send product Shippment
export const sendProductShipping = createAsyncThunk(
  "product/sendProductShipping",
  async (productId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      // console.log(productId)
      const response = await axios.post(
        `${BASE_URL}/product/Shipping/${productId}`,
        {},
        {
          headers: {
            token: token,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to send product request"
      );
    }
  }
);

// Send product Delivery
export const sendProductDelivery = createAsyncThunk(
  "product/sendProductDelivery",
  async (productId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      // console.log(productId)
      const response = await axios.post(
        `${BASE_URL}/product/Delivery/${productId}`,
        {},
        {
          headers: {
            token: token,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to send product request"
      );
    }
  }
);

// Create product item in Cart Received
export const createProductInCartReceived = createAsyncThunk(
  "product/createProductInCartReceived",
  async (cartID, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No access token found");

      const response = await axios.post(
        `${BASE_URL}/cart/builder/${cartID}/addProductToOutCart`,
        {},
        {
          headers: {
            token,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const CartsSlice = createSlice({
  name: "product",
  initialState: {
    allProducts: [],
    items: [],
    loading: false,
    newItemId: null,
    error: null,
    productsLoading: false,
    productsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllProductInCarts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllProductInCarts.fulfilled, (state, action) => {
        state.loading = false;
        state.allProducts = action.payload;
      })
      .addCase(fetchAllProductInCarts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createProductItem.fulfilled, (state, action) => {
        state.newItemId = action.payload.id;
        state.items.push(action.payload);
      })
      .addCase(getProductItemById.fulfilled, (state, action) => {
        state.productsLoading = false;
        state.allProducts = action.payload;
      })
      .addMatcher(
        (action) => action.type.endsWith("/pending"),
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith("/fulfilled"),
        (state) => {
          state.loading = false;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      );
  },
});

export default CartsSlice.reducer;
